var hide = document.getElementById('acceptCookieBar')
hide.onclick = function () {
    var bar = document.getElementById('cookie-bar')
    bar.style.display = 'none'
    var now = new Date()
    var time = now.getTime()
    time += 3600 * 24 * 365 * 1000
    now.setTime(time)
    var rand = Math.random() + Math.random()
    document.cookie =
        'impaddo_cookie=' + rand +
        '; expires=' + now.toUTCString() +
        '; path=/'
}

jQuery(function ($) {
    var counter = 0
    $.each(document.cookie.split(/; */), function () {
        var splitCookie = this.split('=')
        if (splitCookie[0] == 'impaddo_cookie') {
            counter++
            if (splitCookie[1] != '') {

            } else {
                var cB = document.getElementById('cookie-bar')
                cB.style.visibility = 'visible'
            }
        }
    })
    if (counter < 1) {
        var cB = document.getElementById('cookie-bar')
        cB.style.visibility = 'visible'
    }

    //$("#disableGA").click(gaOptout);
})

//fadein logo 
setTimeout(function(){
   $('.homescreen-letters').addClass('fade-in')
}, 100 )

//show menu
$('.impaddo-wrapper').click(function () {

    //act as anchor to home
    if($('.menu-impaddo-letters').hasClass('active-menu')) {
        window.location.href = '/'
    } else {
        $('body').addClass('fixed')
    }

    $('.menu-impaddo-letters').addClass('active-menu')
    $('.x-wrapper').show()
    $('.footer').hide()
    $('.scroll-indicator-wrapper').hide()
    $('.anchor-links-menu').addClass('hide')
    $('.menu-wrapper').addClass('show-menu')
    $('.menu-sidebar').addClass('active-sidebar')
})

//hide menu
$('.x-wrapper').add('.is-anchor').click(function () {
    $('body').removeClass('fixed')
    $('.menu-impaddo-letters').removeClass('active-menu')
    $('.close-x').hide()
    $('.footer').show()

    if($(window).width() > 600) {
        $('.scroll-indicator-wrapper').show()
    }
    
    $('.anchor-links-menu').removeClass('hide')
    $('.menu-wrapper').removeClass('show-menu')
    $('.menu-sidebar').removeClass('active-sidebar')
})

//scroll to top
$('.top').click(function () {
    window.scrollTo({top: 0, behavior: 'smooth'})
})

// recognize scroll over
$(document).on('scroll', function (e) {
    let win = $(window)
    //Hide scroll element and show it if scroll doesnt happen after 3 seconds
    $('.scroll-indicator-wrapper').hide()

    setTimeout(showScrollIndicator, 3000)

    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
        document.getElementById('backToTop').style.display = 'block'
    } else {
        document.getElementById('backToTop').style.display = 'none'
    }
})

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});

function showScrollIndicator() {
    let win = $(window)
    if(win.width() > 600 && $('.scroll-indicator-wrapper').hasClass('move-to-bottom')) {
        if ($(this).scrollTop() + window.innerHeight >= $('.first-animation-wrapper').height()) {
            $('.scroll-indicator-wrapper').hide()
        } else {
            $('.scroll-indicator-wrapper').show()
        }
    }
}